export default {
  ctaText: "Time to distribute",
  sidePanelSubtitle: "Remember, items are still at the warehouse.",
  sidePanelTitle: "",
  tagLabel: "Start of the day"
};
